module.exports = __webpack_public_path__ + "static/media/asian_pear.f2ee728a.png";